<template>
    <div class="row row--select" :class="{ 'row--disabled': disabled }">
        <slot><label :for="id" v-html="label" class="leasingSearchListing__sortLabel" /></slot>
        <div class="inputWrap selectWrap">
            <select :name="name"
                    :id="id"
                    :disabled="disabled"
                    @change="handleChange"
            >
                <option value="" v-if="defaultValue">{{ defaultValue }}</option>
                <option v-for="item in items"
                        :value="item.value"
                        :key="item.value"
                        :selected="item.value == selectedValue"
                >
                    {{ item.name }}
                    <template v-if="item['count']">({{ item.count}})</template>
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultValue: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        items: {
            type: [Array, Object],
            default: () => []
        },
        id: {
            type: String
        },
        label: {
            type: String
        },
        name: {
            type: String,
        },
        selectedValue: {
            type: [String, Number]
        }
    },
    data() {
        return {
            value: '',
        }
    },
    methods: {
        handleChange(e) {
            this.value = e.target.value;
            this.$emit('filter-update', { event: e, value: this.value });
        }
    }
}
</script>
